var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SmartLink',{staticClass:"side-menu-logo",attrs:{"route":_vm.route}},[_c('UkaskoLogo',{staticClass:"side-menu-logo-icon",attrs:{"width":100,"height":18}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }